<template>
    <KSectionHeader
        v-editable="blok"
        as="p"
        :eyebrow="blok.text"
        eyebrow-variant="divider"
    />
</template>

<script setup lang="ts">
import { KSectionHeader } from '@vemedia/karibu'

defineProps<{
    blok: {
        text?: string
    }
}>()
</script>
